import React from 'preact';

export default function Style() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 17.61">
      <g id="style 1" clip-path="url(#clip0_250_32846)">
        <g id="Layer_1-2">
          <path id="Vector" d="M20 0H0V2.03666H20V0Z" />
          <path id="Vector_2" d="M20 9.81693H15V7.78027H20V9.81693ZM12.5051 9.81693H7.50509V7.78027H12.5051V9.81693ZM5 9.81693H0V7.78027H5V9.81693Z" />
          <path id="Vector_3" d="M1.01833 17.607C1.58074 17.607 2.03666 17.1511 2.03666 16.5886C2.03666 16.0262 1.58074 15.5703 1.01833 15.5703C0.455922 15.5703 0 16.0262 0 16.5886C0 17.1511 0.455922 17.607 1.01833 17.607Z" />
          <path id="Vector_4" d="M5.50917 17.607C6.07158 17.607 6.5275 17.1511 6.5275 16.5886C6.5275 16.0262 6.07158 15.5703 5.50917 15.5703C4.94677 15.5703 4.49084 16.0262 4.49084 16.5886C4.49084 17.1511 4.94677 17.607 5.50917 17.607Z" />
          <path id="Vector_5" d="M10 17.607C10.5624 17.607 11.0183 17.1511 11.0183 16.5886C11.0183 16.0262 10.5624 15.5703 10 15.5703C9.43761 15.5703 8.98169 16.0262 8.98169 16.5886C8.98169 17.1511 9.43761 17.607 10 17.607Z" />
          <path id="Vector_6" d="M14.4909 17.607C15.0533 17.607 15.5092 17.1511 15.5092 16.5886C15.5092 16.0262 15.0533 15.5703 14.4909 15.5703C13.9285 15.5703 13.4725 16.0262 13.4725 16.5886C13.4725 17.1511 13.9285 17.607 14.4909 17.607Z" />
          <path id="Vector_7" d="M18.9816 17.607C19.5441 17.607 20 17.1511 20 16.5886C20 16.0262 19.5441 15.5703 18.9816 15.5703C18.4192 15.5703 17.9633 16.0262 17.9633 16.5886C17.9633 17.1511 18.4192 17.607 18.9816 17.607Z" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_250_32846">
          <rect width="20" height="17.6069" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}